import React, { useState, useEffect, useRef } from 'react';
import {
  Play, ChevronRight, Brain, Target, Zap, Users, Star, Menu, X,
  ArrowRight, Check, ChevronDown, Phone, Mail, MapPin,
  Instagram, Linkedin, Youtube, Monitor, Smartphone, Settings,
  Award, TrendingUp, Clock, Shield, ChevronLeft, Calendar

} from 'lucide-react';
import emailjs from '@emailjs/browser';

const SportekWebsite = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const heroRef = useRef(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });


  // Imágenes del carousel
  const carouselImages = [
    {
      url: "/images/sp2.jpg",
      title: "Entrenamiento Profesional",
      description: "Tecnología avanzada para clubes de elite"
    },
    {
      url: "/images/sp5.png",
      title: "Precisión y Control",
      description: "Sensores de última generación"
    },
    {
      url: "/images/sp3.png",
      title: "Análisis de datos",
      description: "Datos para mejor rendimiento"
    },
    {
      url: "/images/sp6.png",
      title: "Tecnología Innovadora",
      description: "El futuro del entrenamiento deportivo"
    }
  ];

  const features = [
    {
      icon: <Brain className="w-7 h-7" />,
      title: "Estimulación Cognitiva",
      description: "Ejercicios que mejoran la toma de decisiones y concentración",
      color: "from-purple-500 to-pink-500"
    },
    {
      icon: <Target className="w-7 h-7" />,
      title: "Precisión Avanzada",
      description: "Sensores de alta tecnología para medición exacta",
      color: "from-blue-500 to-cyan-500"
    },
    {
      icon: <Zap className="w-7 h-7" />,
      title: "Reacción Rápida",
      description: "Mejora los tiempos de respuesta en situaciones críticas",
      color: "from-yellow-500 to-orange-500"
    },
    {
      icon: <Users className="w-7 h-7" />,
      title: "Entrenamiento Grupal",
      description: "Estadísticas para optimización de equipos",
      color: "from-green-500 to-emerald-500"
    }
  ];

  const products = [
    {
      name: "Sistema Básico",
      price: "Consultar",
      features: [
        "4 Arcos con tecnología integrada",
        "Software recreativo",
        "Sistema lumínico y sonoro",
        "Soporte técnico posventa",
        "Caja de procesamiento y comunicaciones",

      ],
      popular: false
    },
    {
      name: "Sistema Premium",
      price: "Consultar",
      features: [
        "4 Arcos con tecnología integrada",
        "Sistema lumínico y sonoro",
        "Software recreativo y estadístico",
        "Entrenamiento personalizado",
        "Soporte técnico posventa",
        "Caja de procesamiento y comunicaciones"
      ],
      popular: true
    },

  ];

  const clientLogos = [
    {
      name: "Boca Juniors",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Boca_Juniors_logo18.svg/174px-Boca_Juniors_logo18.svg.png"
    },
    {
      name: "River Plate",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Logo_River_Plate.png/500px-Logo_River_Plate.png"
    },
    {
      name: "Racing Club",
      logo: "https://upload.wikimedia.org/wikipedia/commons/7/74/Racing_logo14.png"
    },
    {
      name: "Estudiantes",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Escudo_de_Estudiantes_de_La_Plata.svg/350px-Escudo_de_Estudiantes_de_La_Plata.svg.png"
    },
    {
      name: "Independiente",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Escudo_del_Club_Atl%C3%A9tico_Independiente_de_Avellaneda.svg/508px-Escudo_del_Club_Atl%C3%A9tico_Independiente_de_Avellaneda.svg.png"
    }
  ];

  const videos = [
    {
      id: 1,
      title: "Demostración del Sistema Sportek",
      description: "Descubre cómo funciona nuestro sistema de entrenamiento automatizado",
      thumbnail: "https://images.unsplash.com/photo-1486286701208-1d58e9338013?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      videoUrl: "/videos/video2.mp4",
      duration: "0:47"
    },
    {
      id: 2,
      title: "Tecnología de Sensores",
      description: "Kit completo con sensores avanzados y elementos integrados",
      thumbnail: "https://images.unsplash.com/photo-1543351611-58f69d7c1781?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      videoUrl: "/videos/video3.mp4",
      duration: "0:36"
    },
    {
      id: 3,
      title: "Software de Análisis",
      description: "Plataforma de gestión y análisis de rendimiento",
      thumbnail: "https://plus.unsplash.com/premium_photo-1685055940272-62cce291d7d3?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      videoUrl: "/videos/video5.mp4",
      duration: "0:35"
    }
  ];

  // Carousel automático
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Efecto de mouse para hero
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        setMousePosition({
          x: ((e.clientX - rect.left) / rect.width) * 100,
          y: ((e.clientY - rect.top) / rect.height) * 100
        });
      }
    };

    const hero = heroRef.current;
    if (hero) {
      hero.addEventListener('mousemove', handleMouseMove);
      return () => hero.removeEventListener('mousemove', handleMouseMove);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    setIsMenuOpen(false);

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetTop = element.offsetTop - 80;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const openVideoModal = (video) => {
    setSelectedVideo(video);
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await emailjs.send(
        'service_qd4sncr',
        'template_mv3m6un',
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          company: formData.company || 'No especificado',
          message: formData.message,
        },
        'Q7mMMeV9kAn9ZiYf5'
      );

      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
      setTimeout(() => setSubmitStatus(null), 5000);

    } catch (error) {
      console.error('EmailJS error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-sportek-black text-white overflow-x-hidden">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-sportek-black/95 backdrop-blur-md z-50 border-b border-gray-800/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <button onClick={() => scrollToSection('inicio')} className="flex-shrink-0">
                <img
                  src="/images/logo1.png"
                  alt="Sportek"
                  className="h-20 w-auto object-contain"
                />
              </button>
            </div>

            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-6">
                {[
                  { id: 'inicio', label: 'Inicio' },
                  { id: 'productos', label: 'Productos' },
                  { id: 'videos', label: 'Videos' },
                  { id: 'contacto', label: 'Contacto' }
                ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className={`px-3 py-2 text-sm font-medium transition-all duration-300 rounded-md ${activeSection === item.id
                      ? 'text-sportek-red bg-sportek-red/10'
                      : 'text-gray-300 hover:text-white hover:bg-white/5'
                      }`}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-300 hover:text-white p-2"
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-sportek-black/98 backdrop-blur-md border-t border-gray-800/30">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {[
                { id: 'inicio', label: 'Inicio' },
                { id: 'productos', label: 'Productos' },
                { id: 'videos', label: 'Videos' },
                { id: 'contacto', label: 'Contacto' }
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block px-3 py-2 text-base font-medium text-gray-300 hover:text-white hover:bg-white/5 rounded-md w-full text-left transition-colors duration-200"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section
        id="inicio"
        ref={heroRef}
        className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 md:pt-20"
        style={{
          background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(229, 9, 20, 0.08) 0%, transparent 60%)`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-sportek-black via-sportek-gray/30 to-sportek-black"></div>

        <div className="absolute inset-0">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-sportek-red rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `pulse ${1 + Math.random() * 2}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 2}s`
              }}
            ></div>
          ))}
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-fade-in-up">
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">Entrenamiento</span>
              <br />
              <span className="text-white">Deportivo</span>
              <br />
              <span className="text-sportek-red">Automatizado</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              Sistema de entrenamiento que integra tecnología para mejorar la precisión, concentración y reacción de los atletas.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
              <button
                className="group bg-sportek-red hover:bg-sportek-red-dark text-white px-7 py-3 rounded-lg font-medium text-lg transition-all duration-300 transform hover:scale-105 flex items-center space-x-2"
                onClick={() => scrollToSection('videos')}
              >
                <Play className="w-5 h-5" />
                <span>Ver Demo</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>

              <button
                onClick={() => scrollToSection('productos')}
                className="glass-effect text-white px-7 py-3 rounded-lg font-medium text-lg transition-all duration-300 transform hover:scale-105 flex items-center space-x-2"
              >
                <span>Conocer Productos</span>
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>

            {/* MISIÓN Y VISIÓN */}
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-20">
              <div className="glass-effect p-6 rounded-xl text-left">
                <h3 className="text-2xl font-bold text-sportek-red mb-4">Misión</h3>
                <p className="text-gray-300 leading-relaxed">
                  Diseñar soluciones tecnológicas automatizadas de entrenamiento cognitivo aplicado en contexto real de juego para mejorar la velocidad mental, la toma de decisiones, la visión periférica y la precisión respondiendo a distintos estímulos.
                </p>
              </div>

              <div className="glass-effect p-6 rounded-xl text-left">
                <h3 className="text-2xl font-bold text-sportek-red mb-4">Visión</h3>
                <p className="text-gray-300 leading-relaxed">
                  Ser la herramienta que ponga foco en el entrenamiento mental del deportista, estableciendo un nuevo estándar accesible para todos los niveles y contextos deportivos.
                </p>
              </div>
            </div>

            {/* Valores */}
            <div className="glass-effect p-6 rounded-xl max-w-5xl mx-auto mb-20">
              <h3 className="text-2xl font-bold text-sportek-red mb-6 text-center">Valores</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 bg-sportek-red/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <Zap className="w-6 h-6 text-sportek-red" />
                  </div>
                  <h4 className="text-white font-semibold">Innovación Permanente</h4>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-sportek-red/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <TrendingUp className="w-6 h-6 text-sportek-red" />
                  </div>
                  <h4 className="text-white font-semibold">Mejora Continua</h4>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-sportek-red/20 rounded-xl flex items-center justify-center mx-auto mb-3">
                    <Users className="w-6 h-6 text-sportek-red" />
                  </div>
                  <h4 className="text-white font-semibold">Responsabilidad Social</h4>
                </div>
              </div>
              <p className="text-center text-gray-400 italic mt-6 text-sm">
                "Acercamos la tecnología al desarrollo deportivo"
              </p>
            </div>


            {/* Trust indicators */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 mb-20">
              <div className="group text-center p-4 rounded-xl hover:bg-white/5 transition-all duration-300 transform hover:scale-105">
                <div className="w-14 h-14 bg-gradient-to-br from-sportek-red/20 to-sportek-red/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:from-sportek-red/30 group-hover:to-sportek-red/20 transition-all duration-300">
                  <Award className="w-7 h-7 text-sportek-red group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div className="text-white font-semibold text-lg mb-1 group-hover:text-sportek-red transition-colors duration-300">Tecnología Propia</div>
                <div className="text-gray-400 text-sm">Sistema registrado</div>
              </div>

              <div className="group text-center p-4 rounded-xl hover:bg-white/5 transition-all duration-300 transform hover:scale-105">
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500/20 to-blue-500/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:from-blue-500/30 group-hover:to-blue-500/20 transition-all duration-300">
                  <Shield className="w-7 h-7 text-blue-400 group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div className="text-white font-semibold text-lg mb-1 group-hover:text-blue-400 transition-colors duration-300">Soporte Técnico</div>
                <div className="text-gray-400 text-sm">Asistencia continua</div>
              </div>

              <div className="group text-center p-4 rounded-xl hover:bg-white/5 transition-all duration-300 transform hover:scale-105">
                <div className="w-14 h-14 bg-gradient-to-br from-green-500/20 to-green-500/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:from-green-500/30 group-hover:to-green-500/20 transition-all duration-300">
                  <Users className="w-7 h-7 text-green-400 group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div className="text-white font-semibold text-lg mb-1 group-hover:text-green-400 transition-colors duration-300">Para Equipos</div>
                <div className="text-gray-400 text-sm">Entrenamiento grupal</div>
              </div>

              <div className="group text-center p-4 rounded-xl hover:bg-white/5 transition-all duration-300 transform hover:scale-105">
                <div className="w-14 h-14 bg-gradient-to-br from-purple-500/20 to-purple-500/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:from-purple-500/30 group-hover:to-purple-500/20 transition-all duration-300">
                  <Clock className="w-7 h-7 text-purple-400 group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div className="text-white font-semibold text-lg mb-1 group-hover:text-purple-400 transition-colors duration-300">Personalizable</div>
                <div className="text-gray-400 text-sm">Adaptado a necesidades</div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
          <button
            onClick={() => {
              window.scrollTo({
                top: window.innerHeight - 80,
                behavior: 'smooth'
              });
            }}
            className="animate-bounce hover:animate-none transition-all duration-300 cursor-pointer"
          >
            <ChevronDown className="w-6 h-6 text-sportek-red hover:text-white" />
          </button>
        </div>
      </section>

      {/* Carousel Section */}
      <section id="carousel" className="py-16 bg-gradient-to-b from-sportek-black to-sportek-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Sistema Sportek en <span className="text-sportek-red">Acción</span>
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Conoce cómo funciona nuestro sistema de entrenamiento automatizado
            </p>
          </div>

          <div className="relative max-w-5xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden bg-sportek-gray/30">
              <img
                src={carouselImages[currentImage].url}
                alt={carouselImages[currentImage].title}
                className="w-full h-auto object-contain transition-opacity duration-500 max-h-[500px] mx-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none"></div>

              <div className="absolute bottom-6 left-6 right-6 text-white z-10">
                <h3 className="text-2xl font-bold mb-2">{carouselImages[currentImage].title}</h3>
                <p className="text-gray-200">{carouselImages[currentImage].description}</p>
              </div>

              <button
                onClick={() => setCurrentImage((prev) => (prev - 1 + carouselImages.length) % carouselImages.length)}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors duration-300 z-10"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>

              <button
                onClick={() => setCurrentImage((prev) => (prev + 1) % carouselImages.length)}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors duration-300 z-10"
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            </div>

            <div className="flex justify-center space-x-2 mt-6">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImage(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-sportek-red w-8' : 'bg-gray-600 hover:bg-gray-500'
                    }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-sportek-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Características del <span className="text-sportek-red">Sistema</span>
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Hardware y software diseñados para mejorar la experiencia de entrenamiento
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group p-6 rounded-xl glass-effect hover:bg-white/10 transition-all duration-500 transform hover:scale-105 cursor-pointer"
              >
                <div className="text-sportek-red mb-4 transition-colors duration-300">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="productos" className="py-16 bg-sportek-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Nuestros <span className="text-sportek-red">Sistemas</span>
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Opciones adaptadas a diferentes necesidades y presupuestos
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {products.map((product, index) => (
              <div
                key={index}
                className={`relative p-6 rounded-xl transition-all duration-300 transform hover:scale-105 ${product.popular
                  ? 'bg-gradient-to-b from-sportek-red/20 to-sportek-red/5 border-2 border-sportek-red shadow-lg shadow-sportek-red/20'
                  : 'glass-effect hover:bg-white/5'
                  }`}
              >
                {product.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <span className="bg-sportek-red text-white px-3 py-1 rounded-full text-xs font-medium">
                      MÁS COMPLETO
                    </span>
                  </div>
                )}

                <div className="text-center mb-6">
                  <h3 className="text-xl font-semibold text-white mb-3">{product.name}</h3>
                  <div className="text-2xl font-bold text-sportek-red mb-2">{product.price}</div>
                </div>

                <ul className="space-y-3 mb-6">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-3">
                      <Check className="w-4 h-4 text-sportek-red flex-shrink-0" />
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => scrollToSection('contacto')}
                  className={`w-full py-3 rounded-lg font-medium transition-all duration-300 ${product.popular
                    ? 'bg-sportek-red hover:bg-sportek-red-dark text-white'
                    : 'glass-effect text-white hover:bg-sportek-red'
                    }`}
                >
                  Solicitar Información
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Logos Section */}
      <section className="py-12 bg-gradient-to-b from-sportek-gray to-sportek-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h3 className="text-xl font-semibold text-white mb-2">
              Trabajamos Con
            </h3>
            <p className="text-gray-400">Clubes, academias y centros de entrenamiento</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 items-center">
            {clientLogos.map((client, index) => (
              <div
                key={index}
                className="flex items-center justify-center p-4 rounded-lg glass-effect hover:bg-white/5 transition-all duration-300 group"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-12 w-auto object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300 opacity-70 group-hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Videos Section */}
      <section id="videos" className="py-16 bg-sportek-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Demos del <span className="text-sportek-red">Sistema</span>
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Mira cómo funciona nuestro sistema en diferentes escenarios de entrenamiento
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((video) => (
              <div
                key={video.id}
                className="group relative overflow-hidden rounded-xl glass-effect hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
                onClick={() => openVideoModal(video)}
              >
                <div className="relative">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300"></div>

                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 bg-sportek-red rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Play className="w-6 h-6 text-white ml-0.5" />
                    </div>
                  </div>

                  <div className="absolute bottom-3 right-3 bg-black/70 text-white px-2 py-1 rounded text-xs">
                    {video.duration}
                  </div>
                </div>

                <div className="p-4">
                  <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-sportek-red transition-colors duration-300">
                    {video.title}
                  </h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {video.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal para video */}
        {selectedVideo && (
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            onClick={closeVideoModal}
          >
            <div
              className="relative bg-sportek-gray rounded-2xl overflow-hidden max-w-4xl w-full shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-4 right-4 z-10 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white transition-colors duration-300"
                onClick={closeVideoModal}
              >
                <X className="w-5 h-5" />
              </button>

              <video
                controls
                autoPlay
                className="w-full aspect-video"
              >
                <source src={selectedVideo.videoUrl} type="video/mp4" />
                Tu navegador no soporta videos HTML5.
              </video>

              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2">
                  {selectedVideo.title}
                </h3>
                <p className="text-gray-300">
                  {selectedVideo.description}
                </p>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Technology Showcase */}
      <section className="py-16 bg-sportek-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Tecnología <span className="text-sportek-red">Desarrollada</span>
              </h2>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                Nuestro sistema combina sensores y software para crear una herramienta de entrenamiento efectiva y accesible.
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-sportek-red/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Monitor className="w-5 h-5 text-sportek-red" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-lg mb-2">Software Adaptable</h3>
                    <p className="text-gray-300">Plataforma que se ajusta a diferentes tipos de entrenamiento y objetivos.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-sportek-red/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Smartphone className="w-5 h-5 text-sportek-red" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-lg mb-2">Soporte Continuo</h3>
                    <p className="text-gray-300">Asistencia técnica y actualizaciones periódicas incluidas.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-sportek-red/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Settings className="w-5 h-5 text-sportek-red" />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-lg mb-2">Sistema Modular</h3>
                    <p className="text-gray-300">Configuración que puede adaptarse según las necesidades específicas.</p>
                  </div>
                </div>
              </div>

              <button
                className="mt-8 bg-sportek-red hover:bg-sportek-red-dark text-white px-6 py-3 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 flex items-center space-x-2"
                onClick={() => scrollToSection('contacto')}
              >
                <span>Más Información</span>
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>

            <div className="relative">
              <div className="relative z-10">
                <img
                  src="/images/sp1.jpg"
                  alt="Sistema Sportek"
                  className="rounded-xl shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-sportek-red/20 to-transparent rounded-xl"></div>
              </div>

              <div className="absolute -top-4 -right-4 w-16 h-16 bg-sportek-red/20 rounded-full flex items-center justify-center">
                <Award className="w-8 h-8 text-sportek-red" />
              </div>

              <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-full flex items-center justify-center">
                <TrendingUp className="w-10 h-10 text-purple-400" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-20 bg-gradient-to-b from-sportek-black to-sportek-gray relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Contactá con <span className="text-sportek-red">Nosotros</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Dejanos tu consulta y te responderemos a la brevedad para resolver todas tus dudas sobre el sistema
            </p>
          </div>

          <div className="flex justify-center">
            <div className="w-full max-w-2xl">
              <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10">

                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-white mb-2">Formulario de Contacto</h3>
                  <p className="text-gray-300">Completá el formulario con tu consulta</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">

                  {submitStatus === 'success' && (
                    <div className="bg-green-500/20 border border-green-500 rounded-lg p-4 text-center animate-fade-in">
                      <p className="text-green-400 font-semibold flex items-center justify-center space-x-2">
                        <Check className="w-5 h-5" />
                        <span>¡Mensaje enviado con éxito!</span>
                      </p>
                      <p className="text-green-300 text-sm mt-1">Te responderemos a la brevedad</p>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="bg-red-500/20 border border-red-500 rounded-lg p-4 text-center animate-fade-in">
                      <p className="text-red-400 font-semibold flex items-center justify-center space-x-2">
                        <X className="w-5 h-5" />
                        <span>Error al enviar el mensaje</span>
                      </p>
                      <p className="text-red-300 text-sm mt-1">Por favor, verificá los datos e intentá nuevamente</p>
                    </div>
                  )}

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-white font-medium mb-2">
                        Nombre Completo *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-white/5 border border-gray-600/50 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-sportek-red focus:ring-1 focus:ring-sportek-red/50 transition-all duration-300"
                        placeholder="Tu nombre"
                      />
                    </div>
                    <div>
                      <label className="block text-white font-medium mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-white/5 border border-gray-600/50 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-sportek-red focus:ring-1 focus:ring-sportek-red/50 transition-all duration-300"
                        placeholder="tu@email.com"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-white font-medium mb-2">
                        Teléfono *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        className="w-full bg-white/5 border border-gray-600/50 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-sportek-red focus:ring-1 focus:ring-sportek-red/50 transition-all duration-300"
                        placeholder="+54 11 1234-5678"
                      />
                    </div>
                    <div>
                      <label className="block text-white font-medium mb-2">
                        Empresa/Club
                      </label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleInputChange}
                        className="w-full bg-white/5 border border-gray-600/50 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-sportek-red focus:ring-1 focus:ring-sportek-red/50 transition-all duration-300"
                        placeholder="Opcional"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-white font-medium mb-2">
                      Tu Consulta *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows={4}
                      className="w-full bg-white/5 border border-gray-600/50 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-sportek-red focus:ring-1 focus:ring-sportek-red/50 transition-all duration-300 resize-none"
                      placeholder="¿Qué te gustaría saber sobre el sistema Sportek?"
                    ></textarea>
                  </div>

                  <div className="pt-4">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-sportek-red hover:bg-sportek-red-dark text-white py-4 rounded-lg font-bold text-lg transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                    >
                      {isSubmitting ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                          <span>Enviando...</span>
                        </>
                      ) : (
                        <>
                          <Mail className="w-5 h-5" />
                          <span>Enviar Consulta</span>
                        </>
                      )}
                    </button>

                    <p className="text-center text-gray-400 text-sm mt-4">
                      Te responderemos a la brevedad
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-sportek-gray border-t border-gray-800/50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <img
                src="/images/logo1.png"
                alt="Sportek"
                className="h-32 w-auto object-contain mb-4"
              />
              <p className="text-gray-300 mb-6 max-w-md">
                Sistema de entrenamiento automatizado que busca mejorar el rendimiento deportivo a través de la tecnología.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-9 h-9 bg-sportek-red/20 rounded-lg flex items-center justify-center hover:bg-sportek-red transition-colors duration-300">
                  <Instagram className="w-4 h-4 text-sportek-red hover:text-white" />
                </a>
                <a href="#" className="w-9 h-9 bg-sportek-red/20 rounded-lg flex items-center justify-center hover:bg-sportek-red transition-colors duration-300">
                  <Linkedin className="w-4 h-4 text-sportek-red hover:text-white" />
                </a>
                <a href="#" className="w-9 h-9 bg-sportek-red/20 rounded-lg flex items-center justify-center hover:bg-sportek-red transition-colors duration-300">
                  <Youtube className="w-4 h-4 text-sportek-red hover:text-white" />
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4">Productos</h3>
              <ul className="space-y-2">
                <li><a href="#productos" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm">Sistema Básico</a></li>
                <li><a href="#productos" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm">Sistema Premium</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4">Información</h3>
              <ul className="space-y-2">
                <li><a href="#videos" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm">Videos</a></li>
                <li><a href="#contacto" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm">Contacto</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              © 2025 Sportek. Todos los derechos reservados.
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors duration-300">Términos de Uso</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors duration-300">Privacidad</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SportekWebsite;